import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-factura',
  templateUrl: './edit-factura.component.html',
  styleUrls: ['./edit-factura.component.css']
})
export class EditFacturaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
